/* eslint-disable */

import { Howl, Howler } from 'howler';

const state = {
  files: {},
  completeID: null,
};

const mutations = {
  ADD_SOUND(state, payload) {
    
    if (!state.files.length) {
      Howler.autoUnlock = true;
    }

    state.files[payload.id] = new Howl({
      src: [payload.src, payload.src.replace("webm", "mp3")],
      loop: payload.loop || false,
      volume: payload.volume || 1,
      autoplay: payload.autoplay || false,

      onend: !payload.onend ? null : () => {
        state.completeID = payload.id;
      },
      onplayerror: (id) => {
        let sound = state.files[id];
        sound.once('unlock', function () {
          sound.play();
        });
      },

    });

    state.files[payload.id].name = payload.id;
  },
  
  RESET_ENDED(state) {
    state.completeID = null;
  }
};

const actions = {
  /*
  * {
  *   id: String,
  *   loop: Boolean, (optional)
  *   volume: Number, (optional)
  *   autoplay: Boolean, (optional)
  *   onend: Function, (optional)
  *   src: String
  * }
  */
  ADD({commit, getters}, options) {
    if (getters.getByID(options.id)) return;
    
    commit('ADD_SOUND', options);
  },

  /*
  * {
  *   id: String,
  *   volume: Number (optional), 
  *   rate: Number (optional),
  *   }
  */
  PLAY({getters, dispatch}, options) {
    // console.log("PLAY-", options);
    
    const sound = getters.getByID(options.id);
    if(!sound) return;
    
    //stop sound if we play it with fade
    if (options.withFade && getters.isPlaying(options.id)) {
      dispatch('STOP', options.id);
    }
    
    sound.id = sound.play();

    //rate
    if (options.rate && options.rate != 1) {
      sound.rate(options.rate, sound.id);
    }

    //volume
    if (options.volume != null) {
      dispatch('VOLUME', {id: sound.id, volume: options.volume });
    }
  },

  /*
  * {
  *    volumeFrom: Number, (optional)
  *    volumeTo: Number, (optional)
  *    duration: Number, (optional)
  *    fromSound: String (optional)
  *    toSound: String, (optional)
  *    complete: Function (optional)
  *  }
  */
  FADE({ dispatch, getters}, options) {
    if (!options.fromSound) return;
    
    const sound = getters.getByID(options.fromSound);    
    if (!sound) return;
    
    if (!getters.isPlaying(sound.name)) dispatch('PLAY', {id: options.fromSound});
    
    //fade the current sound
    options.volumeFrom = options.volumeFrom != null ? options.volumeFrom : sound.volume();
    options.duration = options.duration || 2;
    
    // console.log("-fade:", options);
    
    sound.fade(options.volumeFrom, options.volumeTo, options.duration * 1000, sound.id);

    if (options.complete != null) {
      sound.once('fade', options.complete);
    }

    if(options.volumeTo === 0 && options.complete === null) {
      sound.once('fade', () => {
        dispatch('STOP', options.fromSound);
      });
    }

    if (options.toSound) {
      dispatch('PLAY', { id: options.toSound, withFade: true, withFadeOptions: {
          fromSound: options.toSound,
          duration:options.duration,
          volumeFrom:0,
          volumeTo:1
        }
      });
    }
  },

  /*
  * {id: String, volume: Number }
  */
  VOLUME({ commit, getters }, options) {
    const sound = getters.getByID(options.id);
    if (!sound) return;

    sound.volume(options.volume);
  },

  /*
  * {id: String, all: Boolean}
  */
  STOP({ state, getters, commit }, options) {
    options.all = options.all || false;

    const sound = getters.getByID(options.id);
    if (!sound) return;
    
    sound.stop(options.all);
    sound.off();
  },

  MUTE({}, value) {
    Howler.mute(value);
  }
};

const getters = {
  getByID: state => id => state.files[id],
  hasEnded: state => state.completeID,
  isPlaying: state => id => {
    const s = state.files[id];
    if(!s) return false;

    return s.playing();
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
